/**
 * Shuttle Thank You Page - Device Detection
 * 
 * Detects user device (iOS/Android) and shows appropriate app store badge
 */

(function($) {
    'use strict';

    /**
     * Initialize device detection for app store badges
     */
    function initAppBadgeDetection() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const iosBadge = $('.shuttle-thank-you__app-badge--ios');
        const androidBadge = $('.shuttle-thank-you__app-badge--android');

        if (!iosBadge.length && !androidBadge.length) {
            return; // Not on thank you page
        }

        // iOS detection
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            if (iosBadge.length) {
                iosBadge.css('display', 'inline-block');
                androidBadge.css('display', 'none');
            } else if (androidBadge.length) {
                // If only Android badge exists, show it as fallback
                androidBadge.css('display', 'inline-block');
            }
        }
        // Android detection
        else if (/android/i.test(userAgent)) {
            if (androidBadge.length) {
                androidBadge.css('display', 'inline-block');
                iosBadge.css('display', 'none');
            } else if (iosBadge.length) {
                // If only iOS badge exists, show it as fallback
                iosBadge.css('display', 'inline-block');
            }
        }
        // Desktop - show both badges
        else {
            iosBadge.css('display', 'inline-block');
            androidBadge.css('display', 'inline-block');
        }
    }

    // Initialize on DOM ready
    $(document).ready(function() {
        initAppBadgeDetection();
    });

})(jQuery);

